import { Autocomplete, Avatar, Box, Checkbox, FormControl, Grid, IconButton, InputAdornment, InputLabel, Link, MenuItem, OutlinedInput, Select, TextField, Tooltip, Typography } from '@mui/material'
import { t } from 'i18next'
import React, { memo, useEffect, useState } from 'react'
import { Ttraining } from '../../shared/types/training.type'
import { capitalize, debounce, sortBy, upperCase } from 'lodash'
import { TQualifyChoices } from '../../shared/types/qualifyChoices.type'
import { Create, ListAlt } from '@mui/icons-material'
import { Icon } from '@iconify/react'
import { routes } from '../../pages/routes'
import { restModalsToInitialState } from '../../store/reducers/modal.reducer'
import { useDispatch } from 'react-redux'
import MoreFieldsSection from './MoreFieldsSection'
import { Ttrack } from '../../shared/types/tracks.type'


type ExamRowProps = {
    exam: Ttraining,
    isExamChecked: boolean,
    qualifyChoices: TQualifyChoices | null,
    handleInputChange: (checked: boolean, exam: Ttraining) => void,
    updateExam: (key: keyof Ttraining | string, value: any, examId: number) => void,
    onUpdateQualifyChoices: <T>(key: keyof TQualifyChoices, value: T) => void

}

function ExamRow({ exam, isExamChecked, qualifyChoices, handleInputChange, updateExam, onUpdateQualifyChoices }: ExamRowProps) {




    //booleans for wheater show select or text field
    const [useCustomTrainingType, setCustomTrainingType] = useState(false)
    const [useCustomTrackName, setCustomTrackName] = useState(false)
    const [useCustomTrackCondition, setCustomTrackCondition] = useState(false)
    const [useCustomRider, setCustomRider] = useState(false)

    const [showMoreOptions, setShowMoreOptions] = useState(false)
    //Effect

    useEffect(() => {
        //Check if Exams has Auto Values

        let training_type = exam?.training_type
        let training_type_auto = exam?.training_type_automatic

        let track_name = exam?.track_name
        let track_name_auto = exam?.track_name_automatic

        let surface = exam?.track_surface
        let surface_auto = exam?.track_surface_automatic

        if (!training_type) {
            //Populate qualify choices With Auto value if exist
            if (training_type_auto) {
                onUpdateQualifyChoices('training_types', training_type_auto)
                updateExam('training_type', training_type_auto, exam.id)
            }
        }

        if (!track_name) {
            //Populate qualify choices With Auto value if exist
            if (track_name_auto) {
                onUpdateQualifyChoices('track_names', track_name_auto)
                updateExam('track_names', track_name_auto, exam.id)
            }
        }

        if (!surface) {
            //Populate qualify choices With Auto value if exist
            if (surface_auto) {
                onUpdateQualifyChoices('track_surfaces', surface_auto)
                updateExam('track_surface', surface_auto, exam.id)
            }
        }


    }, [exam.id])


    const debouncedFn = debounce((key: keyof Ttraining | string, value: any, examId: number) => {
        updateExam(key, value, examId)

    }, 300)


    const toggleMoreOptions = () => {
        setShowMoreOptions(!showMoreOptions)
    }

    const checkForTrackSurface = (track: Ttrack | null) => {
        if (track && 'track_surface' in track) {
            updateExam('track_surface', track.track_surface, exam.id)
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid item md={2} sm={12} xs={12} sx={{ placeSelf: 'center' }}>
                <Typography sx={{ alignSelf: 'center', alignItems: 'center', display: 'flex', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }} variant='caption'>
                    <Checkbox onChange={(_, checked) => handleInputChange(checked, exam)} checked={isExamChecked} ></Checkbox>
                    <a href={routes.DASHBOARD_ROUTES.EXAM_VIEW.replace(':id', String(exam.id))} target="_blank" rel="noopener noreferrer">
                        {upperCase(exam.horse_trainer.horse.name)}

                    </a>
                </Typography>
            </Grid>
            <Grid item md={2} sm={12} xs={12}>

                {/* Training Type */}
                <FormControl fullWidth sx={{ flex: 1, flexDirection: 'row' }}>
                    {
                        !useCustomTrainingType ?
                            <>
                                <Autocomplete
                                    sx={{ flex: 1 }}
                                    options={sortBy(qualifyChoices?.training_types, i => i.display_name)}
                                    getOptionLabel={e => e.display_name}
                                    getOptionKey={option => option.id}
                                    value={qualifyChoices?.training_types.find(e => e['@id'] === exam.training_type?.['@id']) ?? null}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    onChange={(e, value) => {
                                        updateExam('training_type', value, exam.id)
                                    }}
                                    renderInput={(params) => <TextField

                                        {...params} label={t('editTrainingForm:trainingType:label')} />}

                                />
                                <Tooltip title={t('otherTrainingType')}>
                                    <IconButton onClick={() => setCustomTrainingType(true)}>
                                        <Icon icon='quill:add'></Icon>
                                    </IconButton>
                                </Tooltip>
                            </>
                            : <OutlinedInput
                                onChange={event => debouncedFn('new_training_type', event.target.value, exam.id)}

                                endAdornment={
                                    <InputAdornment position="start">
                                        <Tooltip title={t('editTrainingForm:trainingType:label')}>
                                            <IconButton
                                                onClick={() => {
                                                    debouncedFn('new_training_type', '', exam.id)
                                                    setCustomTrainingType(false)
                                                }}
                                                edge="end"
                                            >
                                                <ListAlt></ListAlt>
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                }
                                label={t('editTrainingForm:trainingType:label')}
                                placeholder={t('otherTrainingType')}
                            ></OutlinedInput>
                    }

                </FormControl>
            </Grid>

            {/* Track */}
            <Grid item md={2} sm={12} xs={12}>
                <FormControl fullWidth sx={{ flex: 1, flexDirection: 'row' }}>
                    {
                        !useCustomTrackName ?
                            <>
                                <Autocomplete
                                    sx={{ flex: 1 }}
                                    options={sortBy(qualifyChoices?.track_names, i => i.display_name)}
                                    id="demo-simple-select"
                                    getOptionLabel={e => e.display_name}
                                    getOptionKey={e => e['@id']}
                                    value={qualifyChoices?.track_names.find(e => e['@id'] === exam.track_name?.['@id']) ?? null}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}

                                    onChange={(e, value) => {
                                        checkForTrackSurface(value)
                                        updateExam('track_name', value, exam.id)
                                    }}
                                    renderInput={(params) => <TextField

                                        {...params} label={t('editTrainingForm:trackName:label')} />}

                                />
                                <Tooltip title={t('newTrackName')}>
                                    <IconButton onClick={() => setCustomTrackName(true)}>
                                        <Icon icon='quill:add'></Icon>
                                    </IconButton>
                                </Tooltip>
                            </>


                            : <OutlinedInput
                                onChange={event => debouncedFn('new_track_name', event.target.value, exam.id)}
                                endAdornment={
                                    <InputAdornment position="start">
                                        <Tooltip title={t('navbar:myTracks')}>
                                            <IconButton
                                                onClick={() => {
                                                    debouncedFn('new_track_name', '', exam.id)
                                                    setCustomTrackName(false)
                                                }}
                                                edge="end"
                                            >
                                                <ListAlt></ListAlt>
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                }
                                label={t('editTrainingForm:horseShoeing:label')}
                                placeholder={t('newTrackName')}
                            ></OutlinedInput>
                    }
                </FormControl>
            </Grid>
            {/* Track surface */}
            <Grid item md={2} sm={12} xs={12}>
                <FormControl fullWidth sx={{ flex: 1, flexDirection: 'row' }}>
                    <>
                        <Autocomplete
                            sx={{ flex: 1 }}
                            options={sortBy(qualifyChoices?.track_surfaces, i => i.display_name)}
                            id="demo-simple-select"
                            getOptionLabel={e => e.display_name}
                            getOptionKey={e => e['@id']}
                            value={qualifyChoices?.track_surfaces.find(e => e['@id'] === exam.track_surface?.['@id']) ?? null}
                            isOptionEqualToValue={(option, value) => option.id === value?.id}

                            onChange={(e, value) => { updateExam('track_surface', value, exam.id) }}
                            renderInput={(params) => <TextField
                                {...params} label={t('editTrainingForm:trackSurface:label')} />}

                        />
                    </>

                </FormControl>
            </Grid>
            {/* Track condition */}
            <Grid item md={2} sm={12} xs={12}>

                <FormControl fullWidth sx={{ flex: 1, flexDirection: 'row' }}>

                    {
                        !useCustomTrackCondition ?
                            <>
                                <Autocomplete
                                    sx={{ flex: 1 }}
                                    options={sortBy(qualifyChoices?.track_conditions, i => i.display_name)}
                                    id="demo-simple-select"
                                    getOptionLabel={e => e.display_name}
                                    getOptionKey={e => e['@id']}
                                    value={qualifyChoices?.track_conditions.find(e => e['@id'] === exam.track_condition?.['@id']) ?? null}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}

                                    onChange={(e, value) => { updateExam('track_condition', value, exam.id) }}
                                    renderInput={(params) => <TextField
                                        {...params} label={t('editTrainingForm:trackCondition:label')} />}

                                />
                                <Tooltip title={t('trackCondition:newTrackCondition')}>
                                    <IconButton onClick={() => setCustomTrackCondition(true)}>
                                        <Icon icon='quill:add'></Icon>
                                    </IconButton>
                                </Tooltip>
                            </>

                            : <OutlinedInput
                                onChange={event => debouncedFn('new_track_condition', event.target.value, exam.id)}
                                endAdornment={
                                    <InputAdornment position="start">
                                        <Tooltip title={t('navbar:myTrackConditions')}>
                                            <IconButton
                                                onClick={() => {
                                                    debouncedFn('new_track_condition', '', exam.id)
                                                    setCustomTrackCondition(false)
                                                }}
                                                edge="end"
                                            >
                                                <ListAlt></ListAlt>
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                }
                                label={t('editTrainingForm:trackCondition:label')}
                                placeholder={t('trackCondition:newTrackCondition')}
                            ></OutlinedInput>
                    }
                </FormControl>
            </Grid>
            {/* Riedr name */}
            <Grid item md={2} sm={12} xs={12}>
                <Box display={'flex'}>
                    <FormControl fullWidth sx={{ flex: 1, flexDirection: 'row' }}>
                        {
                            !useCustomRider ?
                                <>
                                    <Autocomplete
                                        sx={{ flex: 1 }}
                                        options={sortBy(qualifyChoices?.riders, i => i.display_name)}
                                        id="demo-simple-select"
                                        getOptionLabel={e => e.display_name}
                                        getOptionKey={e => e['@id']}
                                        value={qualifyChoices?.riders.find(e => e['@id'] === exam.rider?.['@id']) ?? null}
                                        isOptionEqualToValue={(option, value) => option.id === value?.id}
                                        onChange={(e, value) => { updateExam('rider', value, exam.id) }}
                                        renderInput={(params) => <TextField
                                            {...params} label={t('editTrainingForm:riderName:label')} />}

                                    />
                                    <Tooltip title={t('otherRider')}>
                                        <IconButton onClick={() => setCustomRider(true)}>
                                            <Icon icon='quill:add'></Icon>
                                        </IconButton>
                                    </Tooltip>
                                </>

                                : <OutlinedInput
                                    onChange={event => debouncedFn('new_rider', event.target.value, exam.id)}
                                    endAdornment={
                                        <InputAdornment position="start">
                                            <Tooltip title={t('navbar:myRiders')}>
                                                <IconButton
                                                    onClick={() => {
                                                        debouncedFn('new_rider', '', exam.id)
                                                        setCustomRider(false)
                                                    }}
                                                    edge="end"
                                                >
                                                    <ListAlt></ListAlt>
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                    }
                                    label={t('editTrainingForm:riderName:label')}
                                    placeholder={t('otherRider')}
                                ></OutlinedInput>}
                    </FormControl>
                    <IconButton onClick={toggleMoreOptions} size='small'>
                        <Icon icon={!showMoreOptions ? 'prime:chevron-down' : 'prime:chevron-up'}></Icon>
                    </IconButton>
                </Box>
            </Grid>

            <Grid item md={12} xs={12}>
                {/* More fields Section hideable */}
                <MoreFieldsSection
                    isReference={exam?.is_reference}
                    comment={exam.comment}
                    handleCommentChange={(value) => updateExam('comment', value, exam.id)}
                    onChangeReference={(value) => updateExam('is_reference', value, exam.id)}

                    open={showMoreOptions} />
            </Grid>
        </Grid >
    )
}

export default memo(ExamRow)